import createIcon from '../../createIcon';

/**
 * @component @name OnekPlus
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk05IDE1SDcuNVYxMC41SDZWOUg5VjE1Wk0xMy43NSAxNUwxMiAxMi43NVYxNUgxMC41VjlIMTJWMTEuMjVMMTMuNzUgOUgxNS41TDEzLjI1IDEyTDE1LjUgMTVIMTMuNzVaTTE5LjUgMTIuNUgxOFYxNEgxN1YxMi41SDE1LjVWMTEuNUgxN1YxMEgxOFYxMS41SDE5LjVWMTIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OnekPlus = createIcon('OnekPlus', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 15H7.5V10.5H6V9H9V15ZM13.75 15L12 12.75V15H10.5V9H12V11.25L13.75 9H15.5L13.25 12L15.5 15H13.75ZM19.5 12.5H18V14H17V12.5H15.5V11.5H17V10H18V11.5H19.5V12.5Z',
      key: '1d3zzf',
    },
  ],
]);

export default OnekPlus;
